import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.checklist.edit');
import { OnInit, OnDestroy, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

interface ChecklistItem {
    id: string;
    type: string;
    label: string;
    description: string;
    required: boolean;
    options: string[];
    order: number;
    points?: number;
}

interface ChecklistSection {
    id: string;
    title: string;
    description: string;
    order: number;
    items: ChecklistItem[];
    collapsed?: boolean;
    group_title?: string;
    good_multiplier?: number;
    fair_multiplier?: number;
    poor_multiplier?: number;
}

interface SportsGroup {
    title: string;
    good_multiplier: number;
    fair_multiplier: number;
    poor_multiplier: number;
    sections: ChecklistSection[];
    totalItems: number;
}

const INSPECTION_NOTES: { [key: string]: string[] } = {
    bridge: [
        '※ 출렁다리는 해당 시설물 특성에 부합하는 평가항목을 적용하여 평가를 실시한다.',
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제1장 1.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
    tunnel: [
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 환기구 및 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제2장 2.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
    retaining_wall: [
        '※ 평가 시 제외항목 — 콘크리트옹벽: 3항목, 6~9항목, 11항목 / 보강토옹벽: 2항목, 5항목, 7~9항목, 12항목 / 석축: 2항목, 5항목, 7~8항목 / 돌망태옹벽: 1~6항목, 11~12항목',
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 환기구 및 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제13장 13.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
    cut_slope: [
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제14장 14.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
    building: [
        '※ 마감재는 광고판, 옥상 파라펫 등 건축물에 설치되어 탈락·낙하 위험이 있는 설치물을 포함한다.',
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 환기구 및 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제6장 6.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
};

@Component({
    selector: 'wiz-page-checklist-edit',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.checklist.edit/view.scss */
:host {
  display: block;
}`],
})
export class PageChecklistEditComponent implements OnInit, OnDestroy {
    public checklistId: string = '';
    public checklist: any = {};
    public sections: ChecklistSection[] = [];
    public saving: boolean = false;
    public lastSaved: string = '';

    public itemTypes = [
        { value: 'text', label: '단답형', icon: 'fa-font' },
        { value: 'textarea', label: '장문형', icon: 'fa-align-left' },
        { value: 'number', label: '숫자', icon: 'fa-hashtag' },
        { value: 'select', label: '드롭다운', icon: 'fa-caret-down' },
        { value: 'radio', label: '객관식(단일)', icon: 'fa-circle-dot' },
        { value: 'checkbox', label: '객관식(복수)', icon: 'fa-square-check' },
        { value: 'date', label: '날짜', icon: 'fa-calendar-days' },
        { value: 'file', label: '파일 업로드', icon: 'fa-paperclip' },
    ];

    // 점검 양식 관련
    public isInspection: boolean = false;
    public isSports: boolean = false;
    public sportsGroups: SportsGroup[] = [];
    public editingItemId: string = '';
    public editingSectionId: string = '';

    private autoSaveTimer: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.checklistId = WizRoute.segment.id || '';

        if (!this.checklistId) {
            this.service.href('/checklist/list');
            return;
        }

        await this.loadChecklist();
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    ngOnDestroy() {
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
    }

    public async loadChecklist() {
        const { code, data } = await wiz.call('load', { id: this.checklistId });
        if (code !== 200) {
            this.service.href('/checklist/list');
            return;
        }
        this.checklist = data;
        this.isInspection = data.form_type === 'inspection';
        this.isSports = data.form_type === 'sports';
        this.sections = (data.sections || []).map((s: any) => ({
            ...s,
            collapsed: false,
            group_title: s.group_title || '',
            good_multiplier: s.good_multiplier ?? 1,
            fair_multiplier: s.fair_multiplier ?? 0.6,
            poor_multiplier: s.poor_multiplier ?? 0.4,
            items: (s.items || []).map((item: any) => ({
                ...item,
                options: Array.isArray(item.options) ? item.options : [],
                required: !!item.required,
                points: item.points || 0,
            }))
        }));
        if (this.isSports) this.computeSportsGroups();
        this.ref.detectChanges();
    }

    // ==================== 저장 ====================

    public async save() {
        this.saving = true;
        this.ref.detectChanges();

        const sectionsData = this.sections.map(s => ({
            id: s.id,
            title: s.title,
            description: s.description || '',
            group_title: s.group_title || '',
            good_multiplier: s.good_multiplier ?? 1,
            fair_multiplier: s.fair_multiplier ?? 0.6,
            poor_multiplier: s.poor_multiplier ?? 0.4,
            items: s.items.map(item => ({
                id: item.id,
                type: item.type,
                label: item.label,
                description: item.description || '',
                required: item.required,
                options: item.options || [],
                points: item.points || 0,
            }))
        }));

        const { code } = await wiz.call('save', {
            id: this.checklistId,
            title: this.checklist.title || '',
            description: this.checklist.description || '',
            category: this.checklist.category || '',
            status: this.checklist.status || 'draft',
            sections: JSON.stringify(sectionsData),
        });

        this.saving = false;
        if (code === 200) {
            const now = new Date();
            this.lastSaved = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
        }
        this.ref.detectChanges();
    }

    public scheduleAutoSave() {
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
        this.autoSaveTimer = setTimeout(() => this.save(), 3000);
    }

    // ==================== 상태 관리 ====================

    public async toggleStatus() {
        if (this.checklist.status === 'draft') {
            this.checklist.status = 'published';
        } else if (this.checklist.status === 'published') {
            this.checklist.status = 'archived';
        } else {
            this.checklist.status = 'draft';
        }
        await this.save();
    }

    public statusLabel(status: string): string {
        const map: any = { draft: '초안', published: '게시됨', archived: '보관' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-yellow-50 text-yellow-700 border-yellow-200',
            published: 'bg-green-50 text-green-700 border-green-200',
            archived: 'bg-slate-100 text-slate-500 border-slate-200'
        };
        return map[status] || 'bg-slate-100 text-slate-500 border-slate-200';
    }

    // ==================== 섹션 관리 ====================

    public addSection() {
        const id = this.generateId();
        const defaultTitle = this.isInspection
            ? `시설 ${this.sections.length + 1}`
            : this.isSports
            ? `점검항목 ${this.sections.length + 1}`
            : `섹션 ${this.sections.length + 1}`;
        this.sections.push({
            id,
            title: defaultTitle,
            description: '',
            order: this.sections.length,
            items: [],
            collapsed: false,
            group_title: '',
            good_multiplier: 1,
            fair_multiplier: this.isSports ? 0.4 : 0.6,
            poor_multiplier: this.isSports ? 0 : 0.4,
        });
        if (this.isSports) this.computeSportsGroups();
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public removeSection(index: number) {
        this.sections.splice(index, 1);
        if (this.isSports) this.computeSportsGroups();
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public toggleSection(index: number) {
        this.sections[index].collapsed = !this.sections[index].collapsed;
        this.ref.detectChanges();
    }

    public moveSectionUp(index: number) {
        if (index <= 0) return;
        [this.sections[index - 1], this.sections[index]] = [this.sections[index], this.sections[index - 1]];
        if (this.isSports) this.computeSportsGroups();
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public moveSectionDown(index: number) {
        if (index >= this.sections.length - 1) return;
        [this.sections[index], this.sections[index + 1]] = [this.sections[index + 1], this.sections[index]];
        if (this.isSports) this.computeSportsGroups();
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    // ==================== 항목(질문) 관리 ====================

    public addItem(sectionIndex: number, type: string = 'text') {
        const section = this.sections[sectionIndex];
        const id = this.generateId();
        section.items.push({
            id,
            type,
            label: '',
            description: '',
            required: false,
            options: type === 'select' || type === 'radio' || type === 'checkbox' ? ['옵션 1'] : [],
            order: section.items.length,
            points: 0,
        });
        if (this.isInspection || this.isSports) {
            this.editingItemId = id;
        }
        if (this.isSports) this.computeSportsGroups();
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public addInspectionItem(sectionIndex: number) {
        this.addItem(sectionIndex, 'text');
    }

    public addSportsItem(sectionIndex: number) {
        this.addItem(sectionIndex, 'text');
    }

    public removeItem(sectionIndex: number, itemIndex: number) {
        this.sections[sectionIndex].items.splice(itemIndex, 1);
        if (this.isSports) this.computeSportsGroups();
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public moveItemUp(sectionIndex: number, itemIndex: number) {
        if (itemIndex <= 0) return;
        const items = this.sections[sectionIndex].items;
        [items[itemIndex - 1], items[itemIndex]] = [items[itemIndex], items[itemIndex - 1]];
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public moveItemDown(sectionIndex: number, itemIndex: number) {
        const items = this.sections[sectionIndex].items;
        if (itemIndex >= items.length - 1) return;
        [items[itemIndex], items[itemIndex + 1]] = [items[itemIndex + 1], items[itemIndex]];
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public changeItemType(sectionIndex: number, itemIndex: number, newType: string) {
        const item = this.sections[sectionIndex].items[itemIndex];
        item.type = newType;
        if ((newType === 'select' || newType === 'radio' || newType === 'checkbox') && (!item.options || item.options.length === 0)) {
            item.options = ['옵션 1'];
        }
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    // ==================== 점검 양식 전용 ====================

    public startEditItem(itemId: string) {
        this.editingItemId = itemId;
        this.ref.detectChanges();
    }

    public finishEditItem() {
        this.editingItemId = '';
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public startEditSection(sectionId: string) {
        this.editingSectionId = sectionId;
        this.ref.detectChanges();
    }

    public finishEditSection() {
        this.editingSectionId = '';
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public getGlobalItemNumber(sectionIndex: number, itemIndex: number): number {
        let count = 0;
        for (let i = 0; i < sectionIndex; i++) {
            count += this.sections[i].items.length;
        }
        return count + itemIndex + 1;
    }

    public get totalItemCount(): number {
        return this.sections.reduce((sum, s) => sum + s.items.length, 0);
    }

    public facilityTypeLabel(type: string): string {
        const map: any = {
            bridge: '교량, 육교',
            tunnel: '터널, 지하차도',
            retaining_wall: '옹벽',
            cut_slope: '절토사면',
            building: '건축물, 지하도상가',
            soccer_field: '축구장',
            baseball_field: '야구장',
            indoor_arena: '실내경기장(배구, 농구)',
        };
        return map[type] || type;
    }

    // ==================== 체육시설 스포츠 모드 ====================

    public computeSportsGroups() {
        const groups: SportsGroup[] = [];
        let currentGroup: SportsGroup | null = null;
        for (const section of this.sections) {
            const gt = section.group_title || section.title;
            if (!currentGroup || currentGroup.title !== gt) {
                currentGroup = {
                    title: gt,
                    good_multiplier: section.good_multiplier ?? 1,
                    fair_multiplier: section.fair_multiplier ?? 0.6,
                    poor_multiplier: section.poor_multiplier ?? 0.4,
                    sections: [],
                    totalItems: 0,
                };
                groups.push(currentGroup);
            }
            currentGroup.sections.push(section);
            currentGroup.totalItems += section.items.length;
        }
        this.sportsGroups = groups;
    }

    public getSportsItemNumber(groupIndex: number, sectionIndexInGroup: number, itemIndex: number): number {
        let count = 0;
        for (let gi = 0; gi < groupIndex; gi++) {
            count += this.sportsGroups[gi].totalItems;
        }
        for (let si = 0; si < sectionIndexInGroup; si++) {
            count += this.sportsGroups[groupIndex].sections[si].items.length;
        }
        return count + itemIndex + 1;
    }

    public getSectionIndexInSections(section: ChecklistSection): number {
        return this.sections.indexOf(section);
    }

    public get sportsTotalMaxScore(): number {
        return this.sections.reduce((sum, s) =>
            sum + s.items.reduce((is: number, item: any) => is + (item.points || 0), 0), 0);
    }

    public getSportsGroupScore(group: SportsGroup): number {
        let total = 0;
        for (const section of group.sections) {
            for (const item of section.items) {
                total += item.points || 0;
            }
        }
        return total;
    }

    // ==================== 안내 문구 ====================

    public getInspectionNotes(): string[] {
        const ftype = this.checklist?.facility_type || '';
        return INSPECTION_NOTES[ftype] || [];
    }

    // ==================== 옵션 관리 (select/radio/checkbox용) ====================

    public addOption(sectionIndex: number, itemIndex: number) {
        const item = this.sections[sectionIndex].items[itemIndex];
        item.options.push(`옵션 ${item.options.length + 1}`);
        this.ref.detectChanges();
    }

    public removeOption(sectionIndex: number, itemIndex: number, optIndex: number) {
        this.sections[sectionIndex].items[itemIndex].options.splice(optIndex, 1);
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public trackByIndex(index: number): number {
        return index;
    }

    public hasOptions(type: string): boolean {
        return type === 'select' || type === 'radio' || type === 'checkbox';
    }

    public typeIcon(type: string): string {
        const found = this.itemTypes.find(t => t.value === type);
        return found ? found.icon : 'fa-font';
    }

    public typeLabel(type: string): string {
        const found = this.itemTypes.find(t => t.value === type);
        return found ? found.label : type;
    }

    public goBack() {
        this.service.href('/checklist/list');
    }

    private generateId(): string {
        return Array.from({ length: 32 }, () => 'abcdefghijklmnopqrstuvwxyz0123456789'[Math.floor(Math.random() * 36)]).join('');
    }
}

export default PageChecklistEditComponent;